export function getTagStyles(props) {
    const { theme } = props;
    return {
        root: {
            borderRadius: theme.effects.roundedCorner4,
        },
    };
}
//# sourceMappingURL=Tag.styles.js.map